export default "__VITE_ASSET__B9Pmr_B1__"